import React from 'react';
import PropTypes from 'prop-types';
import CheckBox from 'common/components/elements/inputs/checkbox-label';
import Input from "common/components/elements/inputs/inputs";
import Select from 'common/components/modules/select';
import { onWrongPriceLength as onWrongPriceLengthHelper } from 'common/utils/utils';
import { useSelector } from 'react-redux';

const FREE_MESSAGES_LIMIT_FOR_ACTIVE = [
   { name: 'None', mode: '', number_of_free_messages: 0, value: '0_free_message' },
   { name: '5 free at join', mode: 'for_new_members', number_of_free_messages: 5, value: '5_free_message_for_new_members' },
   { name: '5 free every 30 days', mode: 'for_all_members_every_30_days', number_of_free_messages: 5, value: '5_free_message_for_all_members_every_30_days' },
   { name: '10 free at join', mode: 'for_new_members', number_of_free_messages: 10, value: '10_free_message_for_new_members' },
   { name: '10 free every 30 days', mode: 'for_all_members_every_30_days', number_of_free_messages: 10, value: '10_free_message_for_all_members_every_30_days' },
   { name: '15 free at join', mode: 'for_new_members', number_of_free_messages: 15, value: '15_free_message_for_new_members' },
   { name: '15 free every 30 days', mode: 'for_all_members_every_30_days', number_of_free_messages: 15, value: '15_free_message_for_all_members_every_30_days' },
   { name: '20 free at join', mode: 'for_new_members', number_of_free_messages: 20, value: '20_free_message_for_new_members' },
   { name: '20 free every 30 days', mode: 'for_all_members_every_30_days', number_of_free_messages: 20, value: '20_free_message_for_all_members_every_30_days' },
   { name: '25 free at join', mode: 'for_new_members', number_of_free_messages: 25, value: '25_free_message_for_new_members' },
   { name: '25 free every 30 days', mode: 'for_all_members_every_30_days', number_of_free_messages: 25, value: '25_free_message_for_all_members_every_30_days' },
   { name: '50 free at join', mode: 'for_new_members', number_of_free_messages: 50, value: '50_free_message_for_new_members' },
   { name: '50 free every 30 days', mode: 'for_all_members_every_30_days', number_of_free_messages: 50, value: '50_free_message_for_all_members_every_30_days' },
]
const FREE_MESSAGES_LIMIT_FOR_PUBLIC = [
   { name: 'None', mode: '', number_of_free_messages: 0, value: '0_free_message' },
   { name: '5 free for sign up', mode: '', number_of_free_messages: 5, value: '5_free_message' },
   { name: '10 free for sign up', mode: '', number_of_free_messages: 10, value: '10_free_message' },
   { name: '15 free for sign up', mode: '', number_of_free_messages: 15, value: '15_free_message' },
   { name: '20 free for sign up', mode: '', number_of_free_messages: 20, value: '20_free_message' },
   { name: '25 free for sign up', mode: '', number_of_free_messages: 25, value: '25_free_message' },
   { name: '50 free for sign up', mode: '', number_of_free_messages: 50, value: '50_free_message' },
]


const ChatOptions = ({
   inputName,
   onChange,
   maxPrice,
   onWrongPriceLength,
   priceValidation,
   setError,
   data,
   isPriceError,
   type = 'voice_message',
   accessType = 'free', //payed
   onFocus,
   memberType,
   isLimitError,
   checkVoiceLimitValidation,
}) => {
   const screenWidth = useSelector(state => state.common.screenWidth)

   const getState = () => {
      let text = 'Text messages';
      let className = '';
      let priceLable = 'Price for text messages';
      let selectLable = 'Complementary text messages';
      switch (type) {
         case 'voice_message':{
            text = 'Allow voice messages';
            className = 'intercom-access-settings-voice-message';
            priceLable = 'Price for voice message';
            selectLable = 'Complimentary voice messages';
            break;
         }
         case 'photo_message':{
            text = 'Allow image attachments';
            className = 'intercom-access-settings-image';
            priceLable = 'Price for messages with image';
            selectLable = 'Complimentary image messages';
            break;
         }

         default:
            break;
      }
      return { text, className, priceLable, selectLable };
   }

   const getAvailableKey = () => {
      if('text_message' === type) return ''
      return `available_${ type }_for_${ accessType }`;
   }
   const getPriceKey = () => {
      if('text_message' === type) return `price_for_${ type }`
      return `price_for_${ type }_for_${ accessType }`;
   }
   const getComplementaryKey = () => {
      return `free_${ type }s_rules`;
   }
   const getMaxVoiceDurationKey = () => {
      return `max_voice_message_duration_limit_for_${ accessType }`;
   }

   const availableKey = getAvailableKey();
   const priceKey = getPriceKey();
   const complementaryKey = getComplementaryKey();
   const maxVoiceDurationKey = getMaxVoiceDurationKey();
   const getActiveComplementaryType = () => {
      const rules = data?.[complementaryKey];
      if(!rules){
         return 'None'
      }
      const freeMessageNumber = rules?.number_of_free_messages || 0;
      const mode = rules?.mode;
      if(0 === freeMessageNumber || !mode){
         return `${ freeMessageNumber }_free_message`;
      }
      return `${ freeMessageNumber }_free_message_${ mode }`
   }
   const limitData = 'members' === memberType ? FREE_MESSAGES_LIMIT_FOR_ACTIVE : FREE_MESSAGES_LIMIT_FOR_PUBLIC;

   const getActiveComplementaryName = () => {
      const currentValue  = getActiveComplementaryType();
      const activeItem = limitData.find(el => el.value === currentValue);
      return activeItem?.name || 'Select'
   }

   const getLimitErrorText = () => {
      if(Number(data?.[maxVoiceDurationKey]) === 0){
         return 'Min duration is 1 sec';
      }
      return 'Max duration is 600 sec';
   }
   const state = getState();
   return (
      <div className='flex flex-col bg-grey-main p-3 rounded-lg gap-4'>
         {
            'text_message' === type  &&
               <span className='text-major dark:text-major-dark text-base font-semibold leading-[24px]'>{state.text}</span>
         }
         {
            'text_message' !== type  && (
               <CheckBox
                  label={ state.text }
                  name={ `${ availableKey }_${ inputName }` }
                  checked={ data?.[availableKey] }
                  onChange={ (name, value) => {
                     if('voice_message' === type && !checkVoiceLimitValidation(data)){
                        setError('limit', true)
                        return
                     }
                     if('free' !== accessType && priceValidation(data?.[priceKey])) {
                        setError('unlock', true)
                        return
                     }
                     onChange(availableKey, !data[availableKey])
                  } }
                  textColor='major'
                  textSize='base'
                  checkboxSize='5'
                  disabled={ false }
                  padding='0'
                  className='w-full'
                  labelTextClassName={ `${ state.className } font-semibold` }
                  margin='2'
               />
            )
         }
         {
            ('text_message' === type || data[availableKey]) && (
               <>
                  {
                     'payed' === accessType && (
                        <Input
                           width='chat-access-input'
                           label={ state.priceLable }
                           rightText='USD'
                           value={ data?.[priceKey] }
                           name={ `${ priceKey }_${ inputName }` }
                           onChange={ (name, value) => {
                              if(isPriceError) {
                                 setError('unlock', true);
                              }
                              let newValue = value;
                              if(value === '0' || value){
                                 newValue = +value;
                              }
                              // if(onWrongPriceLength(value) || value.length > 6) return
                              onChange(priceKey, newValue)
                           } }
                           autoComplete='off'
                           onInputFocus={ () => onFocus('unlock') }
                           className='access-input'
                           height='10'
                           errorMessage={ isPriceError && priceValidation(data?.[priceKey], false, false, priceKey) ? `Price must be between 0.05 USD and ${ maxPrice } USD` : null }
                           isPriceInput
                           maxPrice={ maxPrice }
                           type={ 'number' }
                        />
                     )
                  }

                  {
                     'voice_message' === type && (
                        <Input
                           width='chat-access-duration-input'
                           label='Max duration limit'
                           rightText='seconds'
                           value={ data?.[maxVoiceDurationKey] }
                           name={ `${ maxVoiceDurationKey }_${ inputName }` }
                           onChange={ (name, value) => {
                              // if(isLimitError) {
                              //    setError('limit', false);
                              // }
                              if(onWrongPriceLengthHelper(value, 600)) return
                              onChange(maxVoiceDurationKey, value);
                           } }
                           pattern='d\*'
                           autoComplete='off'
                           type='number'
                           onInputFocus={ () => onFocus('limit') }
                           className='access-input'
                           onKeyPress={ (e) => {
                              let regex = /[0-9]$/;
                              if(!regex.test(e.nativeEvent.key)) {
                                 e.preventDefault()
                                 return
                              }
                           } }
                           height='10'
                           errorMessage={ !checkVoiceLimitValidation(data) && isLimitError ? getLimitErrorText() : null }
                        />
                     )
                  }
                  {
                     'payed' === accessType  && (
                        <div className='flex flex-col'>

                           <span
                              className='text-major dark:text-major-dark text-base font-medium mb-2' >
                              {state.selectLable}
                           </span>

                           <Select
                              isMobile={ screenWidth < 1025 }
                              tooltipId={ `${ complementaryKey }_${ inputName }` }
                              data={ limitData }
                              onSelect={ (activeOption) => {
                                 let data = {
                                    number_of_free_messages: activeOption.number_of_free_messages,
                                 }
                                 if(activeOption?.mode){
                                    data = {
                                       ...data,
                                       mode: activeOption.mode,
                                    }
                                 }
                                 onChange(complementaryKey, data)
                              } }
                              name={ getActiveComplementaryName() }
                              activeValue={ getActiveComplementaryType() }
                              className='text-sm rounded-lg border border-divider w-full h-10'
                              maxHeight='400px'
                           />
                        </div>
                     )
                  }

               </>
            )
         }
      </div>
   )
}

ChatOptions.propTypes = {
   onChange: PropTypes.func,
   priceValidation: PropTypes.func,
   onWrongPriceLength: PropTypes.func,
   checkVoiceLimitValidation: PropTypes.func,
   maxPrice: PropTypes.number,
   accessType: PropTypes.string,
   setError: PropTypes.func,
   inputName: PropTypes.any,
   isPriceError: PropTypes.bool,
   data: PropTypes.object,
   type: PropTypes.string,
   memberType: PropTypes.string,
   onFocus: PropTypes.func,
   isLimitError: PropTypes.bool,
}

export default ChatOptions
